<template>
    <div>
        <div class="">
            <img src="../../assets/images/img1/aboutUs_head.png" alt="" class="aboutUs_headImg" />
        </div>

        <div class="">
            <div class="cen aboutUs_pos">
                <div class="real_flexDR real_flexSB real_flexAC aboutUs_marL122">
                    <div>
                        <p class="fontS72 fontW600">科技时代</p>
                        <p class="fontS26 real_marT10">速度 / 科技 / 智能 / 改革 / 未来</p>
                        <p class="fontS18 real_marT70 aboutUs_btn">放眼未来,皆有可能</p>
                    </div>
                    <img class="about_topImg" src="../../assets/images/img1/aboutUs_headRight.png" alt="" />
                </div>
            </div>

            <!-- <div class="aboutUs_marT50 aboutUs_pos1">
                <div class="con real_flexDR real_flexAR real_flexSB aboutUs_posLeft">
                    <img class="about_leftImg" src="../../assets/images/img1/aboutUs_left.png" alt="" />
                    <div class="aboutUs_txt">
                        <div class="real_flexDR real_flexAC">
                            <div class="aboutUs_shu real_marR16"></div>
                            <div class="">
                                <p class="fontS36 fontW600">关于我们</p>
                                <p class="fontS18 aboutUs_fontC">About us</p>
                            </div>
                        </div>
                        <div class="aboutUs_marT41 aboutUs_retract">
                            配音小程序是一款专业文字转语音配音软件，采用强大的语音合成技术，为用户打造简单高效的配音服务平台。支持一键合成导出，200+特色智能主播及真人主播声音，囊括男声、女声、童声、方言、新闻、中英、英文等多种发音人。还可添加多种风格背景音乐，自行调节主播音量、配音语速和语调，制定专属您的个性化配音。专业配音、海量主播、操作便捷、功能强大，您的配音首选！更有软萌可爱的鸭鸭，和您一起去探索未知的配音惊喜。线上一体化配音服务，开启专业配音新模式！
                        </div>
                    </div>
                </div>
            </div> -->

            <!-- <div class="con real_flexJC aboutUs_pos2">
                <div class="real_flexDC aboutUs_marT185">
                    <p class="fontS36 real_flexJC fontW600">现有产品</p>
                    <p class="aboutUs_heng">Existing products</p>
                </div>
            </div>

            <div class="con real_flexDR real_flexWW real_flexSB aboutUs_pos2">
                <div class="aboutUs_ours  aboutUs_marT41" v-for="item in productList">
                    <div class="real_flexDC real_flexAC">
                        <img class="aboutUs_Imgs" :src="item.img" alt="">
                        <div class="fontS18 fontWigth aboutUs_marT8 fontW600">{{item.name}}</div>
                    </div>
                    <div class="fontS12 aboutUs_retract">
                        {{item.description}}
                    </div>
                    <div class="aboutUs_download aboutUs_marT8">立即下载体验</div>
                </div>
            </div> -->

            <!-- <div class="aboutUs_marT150 aboutUs_pos2">
                <div class="con real_flexDR real_flexAR real_flexSB aboutUs_posLeft">
                    <div class="aboutUs_txt">
                        <div class="real_flexDR real_flexAC">
                            <div class="aboutUs_shu real_marR16"></div>
                            <div class="">
                                <p class="fontS36 fontW600">服务场景</p>
                                <p class="fontS18 aboutUs_fontC">Service scenario</p>
                            </div>
                        </div>
                        <div class="aboutUs_marT41 aboutUs_retract">
                            可以满足短视频配音、新闻播报、影视剪辑配音、微课配音、儿歌绘本故事制作、有声朗读、动画配音、广告配音、超市播报、促销配音、电商直播、宣传片配音、外语配音、铃声制作、地摊叫卖、企业宣传等多种配音场景。同时拥有海量模板，可快速套用，轻松制作出您需要的场景配音。更有多种工具模块，一键解决您的配音难题。适用于生活中的各行各业，懂您所需!专业级的配音团队、FM的音质标准、完善的售前售后服务，鸭鸭24小时在线等你！
                        </div>
                        <div class="aboutUs_btn fontS14 aboutUs_marT60">配音服务协议</div>
                    </div>
                    <img class="about_leftImg" src="../../assets/images/img1/aboutUs_right.png" alt="" />
                </div>
            </div> -->

            <div class="con real_flexJC aboutUs_pos2">
                <div class="real_flexDC aboutUs_marT185">
                    <p class="fontS36 real_flexJC fontW600">联系我们</p>
                    <p class="aboutUs_heng">Contacs us</p>
                </div>
            </div>

            <!-- 地图区 -->
            <div class="aboutUs_marT41 aboutUs_pos2">
                <baidu-map class="con" style="width: 1440px; height: 320px; background-color: #ccc" @ready="mapReady">
                    <bm-marker :position="point" animation="BMAP_ANIMATION_BOUNCE"></bm-marker>
                </baidu-map>
            </div>

            <div class="aboutUs_marT41 aboutUs_pos2">
                <div class="con real_flexSB">
                    <div>
                        <p class="fontS24 fontWigth fontW600">企业合作</p>
                        <p class="aboutUs_marT16 fontS16">Email:qiuwang@shipook.com</p>
                        <p class="aboutUs_marT16 fontS16">公司电话：0551-65170223</p>
                        <p class="aboutUs_marT16 fontS16">
                            公司地址：安徽省合肥市蜀山区创新产业园二期J2栋A座5楼
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            point: "",
            productList: [
                {
                    name: "配音神器",
                    img: require("../../assets/images/img1/aboutUS_pysq.png"),
                    description:
                        "配音神器是一款文字转语音的配音软件，支持文字转语音，智能合成,有海量样音模板文案,优质背景音库,高端的音频设备,可以自行编辑声音文本内容,导出MP3文件。适用于地摊叫卖,广告促销,有声阅读,视频配音等。",
                },
                {
                    name: "录音转文字助理",
                    img: require("../../assets/images/img1/aboutUS_lyzwzzl.png"),
                    description:
                        "录音转文字助理是一款集手机实时录音、高质量录音转文字为一体的工具类软件。可满足日常办公会议纪要、媒体采访、录音取证、出国旅游实时翻译、讲座记录、听障人士交流等多场景下的录音转文字需求，便捷的为您提供迅速、快捷、高效的录音识别服务。操作简单,提高效率，具有广泛的适用性!",
                },
                {
                    name: "广告配音大全",
                    img: require("../../assets/images/img1/aboutUS_ggpydq.png"),
                    description:
                        "促销广告轻松做，文字立马变声音!超级配音是一款自动把用户文字转换成语音的软件，采用先进的人工智能技术，专门针对促销广告制作场景打造，让用户可以轻松制作促销语音广告，适合门店促销、超市促销、地摊叫卖等场景。",
                },
                {
                    name: "配音极速版",
                    img: require("../../assets/images/img1/aboutUS_pyjsb.png"),
                    description:
                        "配音极速版是一款文字转语音的音频制作软件，支持任意文本内容的便捷配音工具。适用于自媒体视频配音，商场店铺广告促销配音，地摊叫卖配音，课件PPT配音等多种场景。我们有领先的语音技术，优质的配音效果，并且提供海量配音模板、各种特色的发音人主播，让您轻松制作好声音。",
                },
                {
                    name: "Design Play",
                    img: require("../../assets/images/img1/aboutUS_Designplay.png"),
                    description:
                        "Design Play设计稿预览是款能够实时预览Photoshop/Sketch/XD中设计稿的工具，专门为UI设计师、产品、研发等角色准备。它支持Wifi和扫码两种连接模式，能够主动发现PS/Sketch/XD,连接速度快，响应速度极快，支持PS的画板模式。",
                },
            ],
        };
    },
    methods: {
        mapReady({ BMap, map }) {
            this.point = new BMap.Point(117.145029, 31.844197);
            map.centerAndZoom(this.point, 18);
        },
    },
};
</script>




// WEBPACK FOOTER //
// src/view/aboutUs/aboutUs.vue